import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";

// Panchang field keys for display (labels come from i18n)
const PANCHANG_FIELD_KEYS = [
  'day',
  'englishDate',
  'yogam',
  'tithi',
  'nakshatram',
  'rahuKalam',
  'yamagandam',
  'kuligai',
  'abhijitMuhurtham',
  'evening',
  'favorableStars',
];

const formatDateForFirestore = (date) => {
  return date.toISOString().split('T')[0];
};

const Hero = ({ onBook, onCall }) => {
  const { t } = useTranslation();
  const [panchangData, setPanchangData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPanchang = async () => {
      try {
        // Fetch today's panchang
        const today = formatDateForFirestore(new Date());
        const docRef = doc(db, "panchang", today);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setPanchangData(docSnap.data());
        }
      } catch (err) {
        console.error("Error fetching panchang:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchPanchang();
  }, []);

  // Styles for panchang card
  const styles = {
    panchangCard: {
      background: 'rgba(209, 0, 31, 0.04)',
      borderRadius: 12,
      padding: 16,
      marginTop: 12,
    },
    panchangTitle: {
      fontWeight: 700,
      fontSize: 16,
      marginBottom: 12,
      color: 'var(--accent)',
    },
    panchangGrid: {
      display: 'flex',
      flexDirection: 'column',
      gap: 8,
    },
    panchangRow: {
      display: 'flex',
      fontSize: 13,
      borderBottom: '1px solid rgba(0,0,0,0.08)',
      paddingBottom: 6,
    },
    panchangLabel: {
      minWidth: 130,
      color: 'var(--muted)',
      fontWeight: 600,
    },
    panchangValue: {
      color: '#222',
      flex: 1,
      fontWeight: 500,
    },
    emptyState: {
      color: 'var(--muted)',
      fontSize: 13,
      padding: 12,
      textAlign: 'center',
    }
  };

  return (
    <section className="hero">
      <div className="hero-inner" data-reveal>
        {/* gold SVG symbol behind text */}
        <svg
          className="hero-symbol"
          width="320"
          height="320"
          viewBox="0 0 64 64"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <circle cx="32" cy="32" r="30" stroke="none" fill="var(--gold)" />
          <path
            d="M32 12v14"
            stroke="#fff"
            strokeWidth="1.5"
            opacity="0.5"
          />
        </svg>

        <h1 className="hero-head">{t('hero.title')}</h1>
        <p className="hero-sub">
          {t('hero.subtitle')}
        </p>

        <div className="hero-cta">
          <button className="btn" id="heroBook" onClick={onBook}>
            {t('hero.bookNow')}
          </button>
          <button className="btn ghost" id="heroCall" onClick={onCall}>
            {t('hero.callNow')}
          </button>
        </div>

        <div
          style={{
            marginTop: 18,
            color: "var(--muted)",
            fontSize: 14,
          }}
        >
          {t('hero.availability')}
        </div>
      </div>

      <aside
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 12,
        }}
      >
        {/* Panchang Display Card */}
        <div className="hero-inner" data-reveal>
          <div style={styles.panchangTitle}>{t('hero.panchang.title')}</div>

          {loading ? (
            <div style={styles.emptyState}>Loading...</div>
          ) : panchangData ? (
            <div style={styles.panchangGrid}>
              {PANCHANG_FIELD_KEYS.map((key) => (
                <div key={key} style={styles.panchangRow}>
                  <span style={styles.panchangLabel}>{t(`hero.panchang.${key}`)}:</span>
                  <span style={styles.panchangValue}>
                    {panchangData[key] || '-'}
                  </span>
                </div>
              ))}
            </div>
          ) : (
            <div style={styles.emptyState}>
              {t('hero.panchang.noData')}
            </div>
          )}
        </div>

        <div
          className="hero-inner"
          data-reveal
          style={{ textAlign: "center" }}
        >
          <div style={{ fontWeight: 700 }}>{t('hero.quickActions')}</div>
          <div
            style={{
              display: "flex",
              gap: 8,
              justifyContent: "center",
              marginTop: 10,
              flexWrap: "wrap",
            }}
          >
            <button className="btn" id="talk" onClick={onCall}>
              {t('hero.talkToAstrologer')}
            </button>
            <button className="btn ghost" id="appoint" onClick={onBook}>
              {t('hero.bookAppointment')}
            </button>
          </div>
        </div>
      </aside>
    </section>
  );
};

export default Hero;
